import React from "react";
import { TeacherBar } from "../../TeacherBar/TeacherBar.component";
import { Paper } from "@mui/material";
import LettersPage from "../../../../components/pages/LettersPage";

const Cartas = () => {
  return (
    <>
      <TeacherBar />
      <Paper className="my-5 m-auto p-5 max-w-[500px]">
        <LettersPage />
      </Paper>
    </>
  );
};

export { Cartas };
